import moment from "moment";
import React from "react";

// "14:30" → "2:30 pm" (the api sends 24-hour HH:mm).
const clock12 = (hm) => {
  const m = moment(hm, "HH:mm", true);
  return m.isValid() ? m.format("h:mm a") : hm;
};

/**
 * The resident card's 📅 chip — card_summary.appointments
 * ({ today, tomorrow, next }, from the api's AppointmentBrief). Shows only
 * when something is booked today or tomorrow: "📅 Today 14:30 · GP", and an
 * amber "Transport not booked" beside it when that still needs chasing.
 * Never part of the attention chips — an appointment isn't a problem, so it
 * never takes "All on track" away. Renders nothing on older payloads.
 */
const BLUE = {
  background: "rgba(44, 100, 246, 0.08)",
  borderColor: "rgba(44, 100, 246, 0.25)",
  color: "#2c64f6",
};

const CcAppointmentChip = ({ appointments, onOpen }) => {
  const today = Number(appointments?.today) || 0;
  const tomorrow = Number(appointments?.tomorrow) || 0;
  const next = appointments?.next;
  if (!next || today + tomorrow === 0) return null;

  const isToday = next.when === "today";
  const count = isToday ? today : tomorrow;
  const label = [
    `${isToday ? "Today" : "Tomorrow"}${
      next.start ? ` ${clock12(next.start)}` : ""
    }`,
    next.type_label,
  ]
    .filter(Boolean)
    .join(" · ");
  const title = [
    `${isToday ? "Today" : "Tomorrow"}${
      next.start
        ? ` ${clock12(next.start)}${next.end ? `–${clock12(next.end)}` : ""}`
        : ""
    }`,
    next.type_label,
    next.contact,
    next.escort ? `Escort: ${next.escort}` : null,
  ]
    .filter(Boolean)
    .join(" · ");

  const open = (event) => {
    event.stopPropagation();
    event.preventDefault();
    onOpen?.(event);
  };

  return (
    <div className="cc-resident-card__attention">
      <button
        type="button"
        className="cc-resident-card__chip"
        style={BLUE}
        title={title}
        onClick={open}
      >
        <span aria-hidden="true" style={{ marginRight: 4 }}>
          📅
        </span>
        {label}
        {count > 1 ? (
          <span className="cc-resident-card__chip-sub">{` · +${
            count - 1
          }`}</span>
        ) : null}
      </button>
      {next.transport === "not_booked" ? (
        <button
          type="button"
          className="cc-resident-card__chip cc-resident-card__chip--pending"
          title="Transport is needed and not booked yet"
          onClick={open}
        >
          Transport not booked
        </button>
      ) : null}
    </div>
  );
};

export default CcAppointmentChip;
